import { Dialog } from "@dash/dialog";
import { Button } from "@dash/form";
import { MdBarcodeReader, MdClose, MdConveyorBelt } from "react-icons/md";

import { PackageItem } from "@megaron/fulfillment-contracts";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  scannedCode: string | null;
  toPackItems: PackageItem[];
  isPackageSelected: boolean;
  projectedWeight: number | null;
  getDisplayName: (variantId: string, fallbackName: string) => string;
}

export const ScanDialog = ({
  isOpen,
  onClose,
  onConfirm,
  scannedCode,
  toPackItems,
  isPackageSelected,
  projectedWeight,
  getDisplayName,
}: Props) => {
  if (!isOpen || !scannedCode) return null;

  if (!isPackageSelected) {
    return (
      <Dialog
        placement="bottom"
        css={{ minHeight: "unset", height: "auto", maxWidth: "500px" }}
        onClose={onClose}
        header={
          <div css={{ display: "flex", gap: "10px" }}>
            <MdBarcodeReader />
            Brak aktywnej paczki
          </div>
        }
      >
        <div css={{ padding: "0.5rem 0" }}>
          Zanim zeskanujesz produkt, musisz najpierw zaznaczyć paczkę, do której ma zostać dodany.
        </div>
        <div css={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={onClose}>OK</Button>
        </div>
      </Dialog>
    );
  }

  const matchedItem = toPackItems.find((i) => i.barcode === scannedCode);

  if (!matchedItem) {
    return (
      <Dialog
        placement="bottom"
        css={{ minHeight: "unset", height: "auto", maxWidth: "500px" }}
        onClose={onClose}
        header={
          <div css={{ display: "flex", gap: "10px" }}>
            <MdBarcodeReader />
            Nie znaleziono produktu
          </div>
        }
      >
        <div css={{ padding: "0.5rem 0" }}>
          Produkt o kodzie <strong>{scannedCode}</strong> nie należy do zamówienia lub został już w całości zapakowany.
        </div>
        <div css={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={onClose}>Zamknij</Button>
        </div>
      </Dialog>
    );
  }

  const displayName = getDisplayName(matchedItem.variantId, matchedItem.name);

  if (matchedItem.quantity <= 0) {
    return (
      <Dialog
        placement="bottom"
        css={{ minHeight: "unset", height: "auto", maxWidth: "500px" }}
        onClose={onClose}
        header={
          <div css={{ display: "flex", gap: "10px" }}>
            <MdBarcodeReader />
            Brak dostępnych sztuk
          </div>
        }
      >
        <div css={{ padding: "0.5rem 0" }}>
          Produkt <strong>{displayName}</strong> został już w pełni zapakowany.
        </div>
        <div css={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={onClose}>OK</Button>
        </div>
      </Dialog>
    );
  }

  if (projectedWeight !== null && projectedWeight > 25) {
    return (
      <Dialog
        placement="bottom"
        css={{ minHeight: "unset", height: "auto", maxWidth: "500px" }}
        onClose={onClose}
        header={
          <div css={{ display: "flex", gap: "10px" }}>
            <MdBarcodeReader />
            Przekroczony limit wagi
          </div>
        }
      >
        <div css={{ padding: "0.5rem 0" }}>
          Produkt <strong>{displayName}</strong> przekroczyłby maksymalną wagę paczki (25 kg).
        </div>
        <div css={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={onClose}>OK</Button>
        </div>
      </Dialog>
    );
  }

  return (
    <Dialog
      placement="bottom"
      css={{ minHeight: "unset", height: "auto", maxWidth: "500px" }}
      onClose={onClose}
      header={
        <div css={{ display: "flex", gap: "10px" }}>
          <MdBarcodeReader />
          {displayName}
        </div>
      }
    >
      <div css={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
        <Button variant="outline" icon={<MdClose />} css={{ width: "100%" }} onClick={onClose}>
          Anuluj
        </Button>
        <Button icon={<MdConveyorBelt />} css={{ width: "100%" }} onClick={onConfirm}>
          Dalej
        </Button>
      </div>
    </Dialog>
  );
};
